import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent, ref, onMounted, nextTick } from "@vue/composition-api";
import { useAccountStoreActions, useAccountStoreGetters, useAccountStoreMutations } from "@Client/@Modules/main/store/account/account-helpers";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import * as AccountMutations from "@Client/@Modules/main/store/account/account-mutations";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import { useDeprecatedApplicationStoreActions } from "@Client/@Modules/deprecated-application/store/application-helpers";
import * as ApplicationActions from "@Client/@Modules/deprecated-application/store/application-actions";
import { toNumber } from "lodash";
export default defineComponent({
  name: "StartAppModal",
  components: {
    GenericModal,
    SimpleButton
  },
  setup(_, {
    emit
  }) {
    const modalOpened = ref(false);
    const startNewAppModal = ref(null);
    const subdomainId = ref();
    const brokerageId = ref();
    const agentUsername = ref();
    const loading = ref(false);
    const givenName = ref("");
    const familyName = ref("");
    const brokerageName = ref("");
    const {
      ACCOUNT_SUBDOMAIN,
      GET_AGENT_DETAILS_BY_SUBDOMAIN,
      CURRENT_USER_DETAILS,
      AGENT_ACCOUNT_DETAILS
    } = useAccountStoreGetters([AccountGetters.ACCOUNT_SUBDOMAIN, AccountGetters.GET_AGENT_DETAILS_BY_SUBDOMAIN, AccountGetters.CURRENT_USER_DETAILS, AccountGetters.AGENT_ACCOUNT_DETAILS]);
    const {
      LOAD_AGENT_ACCOUNT_DETAILS,
      LOAD_AGENT_DETAILS_WITH_SUBDOMAIN,
      LINK_CLIENT_WITH_BROKERAGE
    } = useAccountStoreActions([AccountActions.LOAD_AGENT_ACCOUNT_DETAILS, AccountActions.LOAD_AGENT_DETAILS_WITH_SUBDOMAIN, AccountActions.LINK_CLIENT_WITH_BROKERAGE]);
    const {
      SET_SELECTED_APPLICATION_ID,
      SET_ACCOUNT_SUBDOMAIN,
      SET_BROKERAGE_SUBDOMAIN
    } = useAccountStoreMutations([AccountMutations.SET_SELECTED_APPLICATION_ID, AccountMutations.SET_ACCOUNT_SUBDOMAIN, AccountMutations.SET_BROKERAGE_SUBDOMAIN]);
    const {
      LOAD_RAW_APPLICATION,
      CREATE_NEW_APPLICATION
    } = useDeprecatedApplicationStoreActions([ApplicationActions.LOAD_RAW_APPLICATION, ApplicationActions.CREATE_NEW_APPLICATION]);
    onMounted(async () => {
      await LOAD_AGENT_ACCOUNT_DETAILS();
      await nextTick(() => {
        var _AGENT_ACCOUNT_DETAIL, _AGENT_ACCOUNT_DETAIL2, _AGENT_ACCOUNT_DETAIL3, _AGENT_ACCOUNT_DETAIL4;
        givenName.value = (_AGENT_ACCOUNT_DETAIL = (_AGENT_ACCOUNT_DETAIL2 = AGENT_ACCOUNT_DETAILS.value.givenName) == null ? void 0 : _AGENT_ACCOUNT_DETAIL2.toString()) != null ? _AGENT_ACCOUNT_DETAIL : "";
        familyName.value = (_AGENT_ACCOUNT_DETAIL3 = (_AGENT_ACCOUNT_DETAIL4 = AGENT_ACCOUNT_DETAILS.value.familyName) == null ? void 0 : _AGENT_ACCOUNT_DETAIL4.toString()) != null ? _AGENT_ACCOUNT_DETAIL3 : "";
      });
    });
    const openModal = async () => {
      subdomainId.value = ACCOUNT_SUBDOMAIN.value;
      await LOAD_AGENT_DETAILS_WITH_SUBDOMAIN();
      modalOpened.value = true;
      startNewAppModal.value.show();
      const agentDetails = GET_AGENT_DETAILS_BY_SUBDOMAIN.value.agentDetails;
      agentUsername.value = agentDetails.agent_username;
      brokerageId.value = toNumber(agentDetails.brokerage_id);
      brokerageName.value = GET_AGENT_DETAILS_BY_SUBDOMAIN.value.brokerageDetails.name;
    };
    const closeModal = () => {
      if (modalOpened.value) {
        modalOpened.value = false;
        startNewAppModal.value.hide();
      }
    };
    const resetModal = () => {
      brokerageId.value = null;
      subdomainId.value = "";
    };
    const startApplication = async () => {
      loading.value = true;
      const applicationId = await CREATE_NEW_APPLICATION({
        currentSubdomain: subdomainId.value,
        brokerageId: brokerageId.value,
        fromClient: true
      });
      SET_BROKERAGE_SUBDOMAIN({
        brokerageId: brokerageId.value
      });
      await SET_SELECTED_APPLICATION_ID(applicationId);
      await SET_ACCOUNT_SUBDOMAIN({
        subdomain: subdomainId.value
      });
      await LINK_CLIENT_WITH_BROKERAGE({
        agentUsername: agentUsername.value,
        clientUsername: CURRENT_USER_DETAILS.value.username,
        email: CURRENT_USER_DETAILS.value.email
      });
      await LOAD_RAW_APPLICATION({
        applicationId: applicationId.applicationId,
        agentUsername: agentUsername.value,
        brokerageId: brokerageId.value
      });
      location.replace(`/${subdomainId.value}#/application?nt=true`);
      emit("refresh");
      startNewAppModal.value.hide();
      loading.value = false;
    };
    return {
      startNewAppModal,
      modalOpened,
      subdomainId,
      brokerageId,
      agentUsername,
      givenName,
      familyName,
      loading,
      brokerageName,
      openModal,
      closeModal,
      resetModal,
      startApplication
    };
  }
});